import React from 'react';
import theme from './FeePreviewCompact.module.scss';
import { ProjectFeeSet, PriceCalculationResult } from '@/types';
import FeePreview from './FeePreview';
import PriceCalculationDisplay from './PriceCalculationDisplay';
import { ProjectCurrencyDisplay } from '@/seller/components/currency';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { Tooltip } from '@/components/Tooltip';
import { classnames } from '@/utils/html';
import { useGetActiveProject } from '@/utils/hooks';
import {
    getMaximumFractionDigits,
    getMinimumProjectFractionDigits,
} from '@/components/localization/CurrencyDisplay';

interface FeePreviewCompactProps {
    price: number;
    quantity: number;
    projectFeeSet?: ProjectFeeSet | null;
    onUpdate?(calculation: PriceCalculationResult | null): void;
    className?: string;
}

const empty = [];

const FeePreviewCompact: React.FC<FeePreviewCompactProps> = ({ projectFeeSet, onUpdate, price, quantity, className }) => {
    const project = useGetActiveProject();
    return (
        <FeePreview
            configuration={projectFeeSet ? projectFeeSet.fees : empty}
            quantity={quantity}
            basePrice={price}
            onUpdate={onUpdate}>
            {(calculation, loading) => (
                <div className={classnames(className, theme.pricePreview)}>
                    <Tooltip
                        color="light"
                        dynamicWidth
                        content={
                            <PriceCalculationDisplay value={calculation ? calculation.steps : empty} loading={loading} />
                        }>
                        <span>
                            {calculation && (
                                <ProjectCurrencyDisplay
                                    value={calculation.finalPrice}
                                    minimumFractionDigits={getMinimumProjectFractionDigits(
                                        project?.decimalOption
                                    )}
                                    maximumFractionDigits={getMaximumFractionDigits(
                                        project?.decimalOption
                                    )}
                                />
                            )}
                        </span>
                    </Tooltip>
                    {loading && <FontAwesomeIcon icon={faSpinner} spin />}
                </div>
            )}
        </FeePreview>
    );
};

export default FeePreviewCompact;
